/* Exact category searches follow the collection maintained in Shopify. */
(function () {
  'use strict';
  var normalize = function (value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase().replace(/\s+/g, ' ');
  };
  var config = function () {
    var node = document.querySelector('[data-search-destinations]');
    if (!node) return null;
    try { return { path: node.dataset.searchPath, entries: JSON.parse(node.textContent) }; }
    catch (_) { return null; }
  };
  var destination = function (term, data) {
    var key = normalize(term);
    if (!key || !data) return null;
    var match = data.entries.find(function (entry) {
      return normalize(entry.title) === key || normalize(entry.collectionTitle) === key;
    });
    if (!match) return null;
    var url = new URL(match.url, window.location.origin);
    return url.origin === window.location.origin ? url : null;
  };
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[role="search"]');
    var input = form && form.querySelector('input[name="q"]');
    if (!input) return;
    var url = destination(input.value, config());
    if (!url) return;
    event.preventDefault();
    window.location.assign(url.href);
  });
  var data = config();
  if (!data || window.location.pathname !== data.path) return;
  var params = new URLSearchParams(window.location.search);
  var url = destination(params.get('q'), data);
  if (!url) return;
  params.forEach(function (value, key) {
    if (key.indexOf('filter.') === 0 || (key === 'sort_by' && value !== 'relevance') || key.indexOf('utm_') === 0) {
      url.searchParams.append(key, value);
    }
  });
  window.location.replace(url.href);
})();
